export const faellesskabItems = [
    {
        id: 1,
        title: "BØRN",
        path: "./Boern",
        cName: "SupLink"
    },
    {
        id: 2,
        title: "JUNIOR-TEEN",
        path: "./JuniorTeen",
        cName: "SupLink"
    },
    {
        id: 3,
        title: "UNGE",
        path: "./Unge",
        cName: "SupLink"
    },
    {
        id: 4,
        title: "KRISTENDOMSKURSUS",
        path: "./Kristendomskursus",
        cName: "SupLink"
    },
    {
        id: 5,
        title: "ANDRE",
        path: "./Andre",
        cName: "SupLink"
    },
]